export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["В процессе"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Завершено"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ожидание"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Следующий"])}
}